<template>
  <CreateEditRoleModal
    v-if="showCreateEditRoleModal"
    @closeModal="closeCreateEditRoleModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Cargos</h6>
      <div class="ms-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Novo Cargo"
          @click="showCreateEditRoleModal = true"
        >
          Novo Cargo
        </button>
      </div>
    </div>
    <ListRoles :roles="roles" />
  </div>
</template>

<script>
import CreateEditRoleModal from '@/components/roles/roles/CreateEditRoleModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListRoles from '@/components/roles/roles/ListRoles.vue'

export default {
  name: 'Roles',

  components: {
    CreateEditRoleModal,
    LoadingData,
    ListRoles,
  },

  data() {
    return {
      loadData: true,
      showCreateEditRoleModal: false,
      roles: [],
    }
  },

  methods: {
    async getRoles() {
      try {
        this.roles = await this.$store.dispatch('getRoles')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeCreateEditRoleModal(loadListRoles) {
      if (loadListRoles) {
        this.loadData = true
        this.getRoles()
      }
      this.showCreateEditRoleModal = false
    },
  },

  mounted() {
    this.getRoles()
  },
}
</script>
